/*
=========================================================
* Material Kit 2 React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-kit-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";

// Material Kit 2 React components
import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";

function Information() {
  return (
    <MKBox component="section" id="about-us" py={4}>
      <Container>
        <Grid
          container
          item
          xs={12}
          lg={6}
          justifyContent="center"
          sx={{ mx: "auto", textAlign: "center" }}
        >
          <MKTypography variant="h2">About Us</MKTypography>
          <MKTypography variant="body1" color="text" mb={2}>
            Welcome to Eye Move Investment, your trusted partner in the import, export, and local
            supply of a wide range of premium products. With a strong commitment to excellence and
            over 7 years of industry experience, we specialize in connecting businesses to
            high-quality solutions, sourced globally and delivered locally. At Eye Move Investment,
            we pride ourselves on our ability to supply a diverse portfolio of products across
            multiple sectors, ensuring that our customers’ needs are always met with precision and
            care. Our expertise spans industries such as manufacturing, engineering, construction,
            mining, automotive, and more. Whether you’re looking to source top-tier equipment,
            materials, or specialized components, Eye Move Investment is the name you can rely on.
          </MKTypography>
        </Grid>
      </Container>
    </MKBox>
  );
}

export default Information;
